import React, { useState } from 'react';
import { useProjectModel } from '../../../model.js';
import { generateReactComponent } from './generate.js';
import { useGenerationTask } from '../hooks/use-generation-task.js';
import { ChooseComponentFolderStep, ChooseComponentNameStep } from './steps.js';
import {
  CompleteGeneration,
  CompleteGenerationMessage,
} from '../CompleteGeneration.js';

export const useGenerateReactComponent = () => {
  const { model } = useProjectModel();

  const [componentName, setComponentName] = useState<string>();
  const [componentFolder, setComponentFolder] = useState<string>();

  const generationTask = useGenerationTask(async () => {
    if (componentName && componentFolder) {
      return generateReactComponent(
        model.projectFolder,
        componentFolder,
        componentName
      );
    }
  }, [componentFolder, componentName]);

  return [
    <ChooseComponentNameStep
      onSubmit={setComponentName}
      componentName={componentName}
    />,
    <ChooseComponentFolderStep
      onSubmit={setComponentFolder}
      componentFolder={componentFolder}
      componentName={componentName}
    />,
    <CompleteGeneration
      generationTask={generationTask}
      extensionType={'site component'}
      successMessage={CompleteGenerationMessage.SuccessMessage({
        // https://dev.wix.com/docs/go-headless
        learnMoreUrl: 'https://dev.wix.com/docs/go-headless',
      })}
    />,
  ];
};
